import './Reusable.scss';
import flame from "../resources/images/flame.svg"

import { HashLink as ScrollLink } from 'react-router-hash-link';
import { setLeadSource } from '../utility/leadSource';
import { track } from '../utility/analytics';

// Every CTA on the site funnels into the contact form rather than firing a
// mailto. A mailto silently does nothing in a desktop browser with no mail
// client configured — the lead just vanishes — and for everyone it does work
// for, it opens a blank compose window and makes them do the writing.
//
// HashLink rather than a bare scroll so this still works from /founder, where
// the form isn't on the page: it navigates home first, then scrolls.
// The obfuscated address lives on in Contact.js as the fallback path.
//
// `source` names the section this instance sits in and rides along to the
// inbox — without it every submission looks identical in origin. Callers
// should always pass one; see src/utility/leadSource.js.
function Button(props) {
    return (
        <ScrollLink
            to="/#contact"
            className="Button"
            onClick={() => {
                setLeadSource(props.source)
                track('cta-click', { source: props.source })
            }}>
            <span>{props.title}</span>
            {
                props.flameon ?
                <img src={flame} alt="" aria-hidden="true" /> :
                null
            }
        </ScrollLink>
    );
}

export {
    Button,
};
